<div *ngFor="let serie of rxSeries" class="serie-container" (click)="openSerie(serie);">
    <fa-icon [icon]="['fas','x-ray']" size="2x"></fa-icon>
    <p>{{ serie.name }}</p>
</div>

